import Error from 'components/alerts/Error'
import { Text } from 'components/common/form/modules/input/Text'
import { getUsers } from 'components/graphql/queries';
import TicketQRScanner from 'components/ticket-scanner/modules/TicketQRScanner';
import * as JSCookie from 'js-cookie';
import React from 'react';
import FadeIn from 'react-fade-in'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { DropdownItem, DropdownMenu, DropdownToggle, Input, UncontrolledDropdown } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import { activatePrivateCode, getByCode } from '../../../../../components/graphql/queries/ticket';
import { getAllTicketBankItems } from '../../../../../components/graphql/queries/ticketBank';
import TicketListItem from '../../../../../components/platform/ticket-list/TicketListItem';
import { parseCodeFromURL } from '../../../../../components/ticket-scanner/methods';
import { stripUriParamsString } from '../../../../../lib/utils/helpers';
import UserDucks from '../../../../../stores/ducks/User.duck';

class PrintedTicketsActivationModal extends React.Component<
    { [label: string]: any },
    { [label: string]: any }
    > {
    constructor(props) {
        super(props);
        this.fetchNeededData = this.fetchNeededData.bind(this);
        this.fetchActivatedTicketData = this.fetchActivatedTicketData.bind(this);

        this.state = {
            tickets: [],
            activatedTickets: [],
            isLoading: true,
            mode: "camera",
            codeExternal: "",
            codeFive: "",
            ticketOrder: {},
            ticketMap: {},
            formData: { comment: "" },
            scannedTickets: [],
            scannedCodes: [],
            activatedCount: 0,
            amountToActivate: 0,
            activationStarted: false,
            error: false,
            activationFinished: false,
            multipleCount: 0,
            soldOut: false,
            timer: 0
        };

        this.getQty = this.getQty.bind(this);
        this.countTotalPrice = this.countTotalPrice.bind(this);
        this.countTotalTickets = this.countTotalTickets.bind(this);
        this.handleAddTicket = this.handleAddTicket.bind(this);
        this.handleScannedCode = this.handleScannedCode.bind(this);
        this.handleChangeMode = this.handleChangeMode.bind(this);
        this.handleStartActivation = this.handleStartActivation.bind(this);
        this.handleFiveChange = this.handleFiveChange.bind(this);
        this.handleExternalChange = this.handleExternalChange.bind(this);
        this.handleBackToActivation = this.handleBackToActivation.bind(this);
    }

    public handleFiveChange(e: any) {
        const val: string = e.target.value;

        this.setState({ codeFive: val }, () => {
            if (val.length === 5) {
                this.setState({ codeFive: "" });
                this.handleScannedCode(val);
            }
        });
    }

    public handleExternalChange(e: any) {
        const val: string = e.target.value;
        const maybeCode = parseCodeFromURL(val);

        this.setState({ codeExternal: val }, () => {
            if (maybeCode !== false && maybeCode.length === 5) {
                this.setState({ codeExternal: "" }, () => {
                    this.handleScannedCode(maybeCode);
                });
            }
        });
    }

    public handleStartActivation(e?: any) {
        e.preventDefault();
        this.setState({ activationStarted: true });
    }

    public handleAddTicket(e: any, id: string, add: boolean) {
        e.preventDefault();
        const ticketOrder = this.state.ticketOrder;

        let count = 0;

        if (add) {
            count = 1;
        } else {
            count = -1;
        }

        if (add && this.state.tickets[this.state.ticketMap[id]].quantity === -1) {
            // Get total count and compare that to remaning capactiy.
            // Then proceed
            let totalSoFar = 0;
            Object.keys(ticketOrder).map(key => {
                if (this.state.tickets[this.state.ticketMap[key]].quantity === -1) {
                    totalSoFar += ticketOrder[key].count
                }
            })
            if (totalSoFar >= this.state.capacityRemaining) {
                return
            }
        }

        let item: any = {};
        item = this.state.tickets.find(i => {
            return i._id.toString().trim() === id.toString().trim()
        })


        if (ticketOrder[id] === undefined) {
            if (add) {
                ticketOrder[id] = {
                    count: 1,
                    price: item.price
                };
                this.setState({ ticketOrder });
            } else {
                ticketOrder[id] = {
                    count: 0,
                    price: item.price
                };
            }
        } else {
            if (add) {
                if (
                    this.state.ticketOrder[id].count < item.available
                ) {
                    ticketOrder[id].count += count;
                    this.setState({ ticketOrder });
                }
            } else {
                if (ticketOrder[id].count > 0) {
                    ticketOrder[id].count -= 1;
                    this.setState({ ticketOrder });
                }
            }
        }
    }

    public componentDidMount() {
        this.fetchNeededData();
    }

    public countTotalPrice() {
        let totalPrice = 0;
        Object.keys(this.state.ticketOrder).forEach(tkey => {
            totalPrice +=
                this.state.ticketOrder[tkey].count * this.state.ticketOrder[tkey].price;
        });

        return totalPrice;
    }

    public countTotalTickets() {
        let totalTickets = 0;
        Object.keys(this.state.ticketOrder).forEach(tkey => {
            totalTickets += this.state.ticketOrder[tkey].count;
        });

        return totalTickets;
    }

    public handleFormInputChange(e: any) {
        const { name, value } = e.target;

        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    }

    /**
     * Used to resolve current count of picked ticket item
     *
     * @param titemId
     */
    public getQty(titemId: string): number {
        return this.state.ticketOrder[titemId]
            ? this.state.ticketOrder[titemId].count
            : 0;
    }

    public handleChangeMode(mode: string) {
        this.setState({
            mode,
            error: false
        });
    }

    public fetchNeededData() {

        const eventId = stripUriParamsString(this.props.eventId);

        // console.log(this.props.event.hosts)
        fetchGraphQL(getAllTicketBankItems(), undefined, {
            eventId
        }).then((resultInventory: any) => {
            const ticketMap = {};
            if (resultInventory && resultInventory.ticketBank) {

                const filteredInventory = resultInventory.ticketBank.get.filter((item) => {
                    return (item.promoterId !== null && (item.referral === null || item.referral === false) && item.promoterId === this.props.user.id)
                })

                filteredInventory.forEach((pt, index) => {

                    ticketMap[pt._id] = index;
                    fetchGraphQL(getUsers(), JSCookie.get("token"), {
                        ids: [pt.promoterId]
                    }).then((res) => {
                        if (res.user.findByIds[0] === undefined) {
                            pt.promoterName = ''
                            pt.promotoerLastName = ''
                        } else {
                            pt.promoterName = res.user.findByIds[0].name;
                            pt.promoterLastName = res.user.findByIds[0].lastname;
                        }

                    })

                });

                this.setState({
                    tickets: filteredInventory || [],
                    ticketMap,
                    isLoading: false
                });
            } else {
                this.setState({
                    isLoading: false
                });
            }
        });

    }

    public fetchActivatedTicketData(aticketCode: string) {
        // Fetching Ticket
        fetchGraphQL(getByCode(), undefined, {
            ticketCode: aticketCode
        }).then(res => {
            // console.log(res);
            // If Ticket is null then don't load other data
            if (res === null) {
                return;
            }
            this.setState(
                {
                    activatedTickets: [...this.state.activatedTickets, res.ticket.get]
                }
            );
            if (this.state.activatedCount === this.countTotalTickets()) {

                this.setState({
                    activationFinished: true
                });
            }
        })
    }

    public handleScannedCode(code: string) {

        // Interval of 1.5 seconds for the batch activation tickets 
        if (Date.now() - this.state.timer < 1500 || this.state.soldOut) {
            return;
        }

        this.props.changeMade();
        const eventId = stripUriParamsString(this.props.eventId);
        const ticketComponents: any[] = [];
        let totalAmount = 0;

        Object.keys(this.state.ticketOrder).forEach(tkey => {
            ticketComponents.push({
                ticketBankId: tkey,
                count: this.state.ticketOrder[tkey].count
            });
            totalAmount += this.state.ticketOrder[tkey].count;
        });
        fetchGraphQL(activatePrivateCode(), undefined, {
            ticketCode: code,
            eventId,
            ticketComponents,
            notes: this.state.formData.comment.trim()
        }).then(response => {
            if (
                response &&
                response.ticket &&
                response.ticket.activate &&
                response.ticket.activate !== "false"
            ) {
                if (this.props.single === true) {
                    this.fetchActivatedTicketData(response.ticket.activate);
                    this.setState({
                        scannedCodes: [...this.state.scannedCodes, code],
                        activatedCount: this.state.activatedCount + totalAmount
                    });
                } else {
                    if (response.ticket.activate === 'ERROR_SOLD_OUT') {
                        this.setState({ soldOut: true })
                    } else {
                        this.setState({
                            multipleCount: this.state.multipleCount + 1,
                            error: false,
                            soldOut: false,
                            timer: Date.now()
                        })
                    }
                }
            } else {
                this.setState({
                    error: true
                });
            }
        });
    }

    public handleBackToActivation() {
        this.setState({
            tickets: [],
            activatedTickets: [],
            mode: "camera",
            codeExternal: "",
            codeFive: "",
            ticketOrder: {},
            ticketMap: {},
            formData: { comment: "" },
            scannedTickets: [],
            scannedCodes: [],
            activatedCount: 0,
            amountToActivate: 0,
            activationStarted: false,
            error: false,
            activationFinished: false,
            isLoading: true
        });
        this.fetchNeededData();
    }

    public render() {
        if (this.state.activationStarted === false) {

            const tickets = this.state.tickets.sort((a, b) => {
                if (a.price < b.price) {
                    return -1;
                }
                if (a.price > b.price) {
                    return 1;
                }
                return 0;
            })

            return (
                <div>
                    <div>
                        <FadeIn delay="200" transitionDuration="500">
                            <div>
                                {
                                    this.props.single ? null : <p>
                                        Embed offers into Isotope’s printed tickets until you run out of inventory.
                                        Each printed ticket activated will contain the offer you customize below.
                                        <br />
                                    </p>
                                }
                                <p />
                                {
                                    tickets.length > 0
                                        ? tickets.map((ticket: any) => {
                                            return (
                                                <TicketListItem
                                                    key={"titem-" + ticket._id}
                                                    price={ticket.price}
                                                    name={ticket.name}
                                                    promoterId={ticket.promoterId}
                                                    id={ticket._id}
                                                    available={ticket.available}
                                                    qty={this.getQty(ticket._id)}
                                                    handleAdd={this.handleAddTicket}
                                                    handleSubstract={this.handleAddTicket}
                                                    hidePromoterName={true}
                                                    currency={this.props.event.currency && this.props.event.currency === 'INR' ? 'INR' : 'USD'}
                                                />
                                            )
                                        }
                                        ) : <h3 style={{ width: '100%', color: '#8c8d94' }}>Contact event host for tickets to sell.</h3>}
                                <p><br /></p>
                                <Text label="Who's this for?" value={this.state.formData.comment}
                                    onChange={e =>
                                        this.handleFormInputChange({
                                            target: {
                                                name: "comment",
                                                value: e.target.value
                                            }
                                        })
                                    }
                                    placeholder='(Optional)'
                                />
                                <p />
                                <div>
                                    {
                                        this.state.tickets.length > 0 ?
                                            <div className='align-center'>
                                                <h6 className="pt-2">
                                                    Subtotal<br />
                                                    <div className="sexyBlack">
                                                        {
                                                            this.props.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                                        }
                                                        {(this.countTotalPrice() / 100).toFixed(2)}
                                                    </div>
                                                </h6>
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                            <p>
                                <br />
                            </p>
                        </FadeIn>
                    </div>
                    <br />
                    <div className="Seperate-Buttons" style={{ paddingBottom: '50px' }}>

                        <button
                            className='new-button-white-3'
                            style={{ border: 'none' }}
                            onClick={this.props.onClose}
                        >
                            CANCEL
                        </button>
                        {
                            this.countTotalTickets() === 0 ? null :
                                <button
                                    className="new-button-white-3"
                                    onClick={this.handleStartActivation}
                                    style={{
                                        border: 'none'
                                    }}
                                >
                                    START
                                </button>
                        }
                    </div>
                </div>
            );
        }
        else if (!this.state.activationFinished) {
            return (
                <div>
                    <div>
                        <p />
                        <h5>
                            {this.state.scannedCodes.lenght > 0
                                ? "Last scanned code '" +
                                this.state.scannedCodes[this.state.scannedCodes.length - 1] +
                                "'"
                                : ""}
                        </h5>
                        <div>
                            <div>
                                <div style={{ textAlign: 'center', width: '100%' }}>
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            caret={true}
                                            tag="div"
                                            className="new-button-white-3"
                                            style={{ width: '125px' }}
                                        >
                                            {
                                                this.state.mode === '5digit' ?
                                                    'BY ID' : 'CAMERA'
                                            }
                                        </DropdownToggle>
                                        <DropdownMenu style={{ borderRadius: '20px' }}>
                                            <DropdownItem
                                                onClick={e => this.handleChangeMode("5digit")}
                                            >
                                                BY ID
													</DropdownItem>
                                            {/* <DropdownItem
                                                onClick={e => this.handleChangeMode("external")}
                                            >
                                                HAND SCANNER
													</DropdownItem> */}
                                            <DropdownItem
                                                onClick={e => this.handleChangeMode("camera")}
                                            >
                                                CAMERA
													</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                                {
                                    this.props.single ? null : <div style={{ width: '100%' }}>
                                        <p><br /></p>
                                        <p style={{ width: '100%', textAlign: 'center' }}>
                                            <br />
                                            Offers Created<br />
                                            <h4 className="sexyBlack">
                                                {this.state.multipleCount}
                                            </h4>
                                        </p>
                                    </div>
                                }
                                <p><br /></p>
                                {this.state.mode === "external" ? (
                                    <Input
                                        autoFocus={true}
                                        placeholder="Use your scanner to provide input..."
                                        value={this.state.codeExternal}
                                        onChange={this.handleExternalChange}
                                        className="text-center"
                                    />
                                ) : null}
                                {this.state.mode === "5digit" ? (
                                    <Input
                                        placeholder="enter 5 digit code (xxxxx)..."
                                        autoFocus={true}
                                        value={this.state.codeFive}
                                        onChange={this.handleFiveChange}
                                        className="text-center"
                                    />
                                ) : null}
                                {this.state.mode === "camera" ? (
                                    <TicketQRScanner onSuccess={this.handleScannedCode} />
                                ) : null}
                            </div>
                            <p>
                                <br />
                            </p>
                        </div>
                        {this.state.soldOut === true ? <Error
                            content={"Ticket activation failed. Some or all of the included ticket types are sold out. " + this.state.multipleCount + " tickets have been activated so far."}
                        /> : null}
                        {this.state.error === true && !this.state.soldOut ? <Error content={"Ticket has been used, or does not exist"} /> : null}
                    </div>
                    <br />
                    <div className="Seperate-Buttons" style={{ paddingBottom: '50px' }}>

                        <button
                            className='new-button-white-3'
                            style={{ border: 'none' }}
                            onClick={this.props.onClose}
                        >
                            {
                                this.props.single ? "CANCEL" : "DONE"
                            }
                        </button>
                    </div>
                </div>
            );
        }
        return (
            <div>
                <div className="text-center">
                    <h3 className="sexyBlack">
                        Ticket has been successfully activated!<br />
                        <br />
                    </h3>
                </div>

                <div>
                    <table className="table">
                        <tr>
                            <th className="text-left">CODE</th>
                            <th className="text-center">TICKET TYPE</th>
                            <th className="text-center">COUNT</th>
                            <th className="text-center">PRICE</th>
                        </tr>

                        {
                            this.state.activatedTickets[0].ticketComponents.map(ticket => {
                                if (ticket.count !== 0) {
                                    return (
                                        <tr key={"tk-" + ticket.name}>
                                            <td className="text-left">{this.state.activatedTickets[0].code}</td>
                                            <td className="text-center">{ticket.name}</td>
                                            <td className="text-center">{ticket.count}</td>
                                            <td className="text-center">
                                                {
                                                    this.props.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                                }
                                                {((ticket.price / 100) * ticket.count).toFixed(2)}
                                            </td>
                                        </tr>
                                    );
                                }
                            })}

                    </table>
                </div>
                <p />
                <div className="Seperate-Buttons" style={{ paddingBottom: '50px' }}>

                    <button
                        className='new-button-white-3'
                        style={{ border: 'none' }}
                        onClick={this.props.onClose}
                    >
                        DONE
                    </button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: UserDucks.getUser(state)
    };
};

export default connect(mapStateToProps)(withRouter(PrintedTicketsActivationModal));



// WEBPACK FOOTER //
// ./src/pages/manage/tickets/activate/digital/PrintedTicketsActivationModal.tsx